import {useUserSettings} from "../store/userSettings/reducer";
import {useLocalStorage} from "@rehooks/local-storage";
import {LocalStorageKeys} from "../common/types";
import {UsersSettingsAPI} from "../services/UsersSettingsAPI";

type BadgeStorage = Record<string, boolean>;

export const useBadgeDismiss = () => {
    const userSettings = useUserSettings();
    const api = new UsersSettingsAPI();
    const labelInitStatus = userSettings.labelNew;

    let [badges, setBadges] = useLocalStorage<BadgeStorage>(LocalStorageKeys.BadgesDismiss, labelInitStatus);

    if (badges === null) {
        badges = labelInitStatus;
    }

    const isShowBadge = (key: string) => {
        if (!badges!.hasOwnProperty(key)) {
            return false;
        }

        if (badges!.hasOwnProperty(key) && !badges![key]) {
            return false;
        }

        return true;
    };

    const markAsVisited = (key: string) => {
        const currentValue = badges![key] ?? null;
        if (currentValue) {
            badges![key] = false;
            setBadges(badges!);

            api.markBadge(key).catch((_) => {});
        }
    }

    return {
        badges,
        setBadges,
        labelInitStatus,
        isShowBadge,
        markAsVisited
    };
};
